export * from './app.component';
export * from './app.module';



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/index.ts